import React from 'react';

import {
  Button, Card, CardHeader, Col, Row,
  Table
} from 'reactstrap';
import Datetime from 'react-datetime';
import PropTypes from 'prop-types';

export default function NeurographTable({
  columns,
  data,
  handleRowSelect
}) {
  return (
    <Card>
      <TableCardHeader
        handleStartDateChange={() => {}}
        handleEndDateChange={() => {}}
        handleCompare={() => {}}
        startDate={new Date()}
        endDate={new Date()}
      />
      <Table className="align-items-center table-flush" responsive>
        <TableHeader columns={columns} />
        <TableBody 
          columns={columns} 
          data={data} 
          handleRowSelect={handleRowSelect}
        />
      </Table>
    </Card>
  );
}

function TableCardHeader({
  handleStartDateChange, 
  handleEndDateChange, 
  handleCompare, 
  startDate, 
  endDate
}) {
  return (
    <CardHeader className="border-0">
      <Row>
        <Col className="col-6">
          <h6 className="surtitle">Activity</h6>
          <h3 className="mb-0">Customer Personas</h3>
        </Col>
        <Col className="col-2">
          <span className="text-primary">Start Date</span>
          <Datetime
            dateFormat="MM/DD/YYYY"
            onChange={handleStartDateChange}
            timeFormat={false}
            value={startDate}
          />
        </Col>
        <Col className="col-2">
          <span className="text-primary">End Date</span>
          <Datetime
            dateFormat="MM/DD/YYYY"
            onChange={handleEndDateChange}
            timeFormat={false}
            value={endDate}
          />
        </Col>
        <Col className="col-2 position-relative">
          <Button
            className="bg-transparent border-primary text-dark position-absolute bottom-0"
            id="run"
            onClick={handleCompare}
          >
            Compare Dates
          </Button>
        </Col>
      </Row>
    </CardHeader>
  );
}

function TableHeader({ columns }) {
  return (
    <thead className="thead-light">
      <tr>
        {columns.map((column) => (
          <th
            key={column.key}
            className="sort"
            data-sort={column.key}
            scope="col"
            style={column.style || {}}
          >
            <span>{column.label}</span>
          </th>
        ))}
      </tr>
    </thead>
  );
}

function TableBody({
  columns, data, handleRowSelect 
}) {
  // TODO: customize cell click logic
  return (
    <tbody>
      {data.map((row, index) => (
        <tr key={index} onClick={() => handleRowSelect(row)}>
          {columns.map((column) => (
            <td key={column.key} className={column.className || ''}>
              {row[column.key]}
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  );
}

NeurographTable.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  })).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.arrayOf(PropTypes.object).isRequired
};
